const CurrencyList = ["CZK", "EUR", "MDL", "PLN", "UAH", "USD"];

// https://www.eurochange.co.uk/travel-money/world-currency-abbreviations-symbols-and-codes-travel-money
const Currency2Symbol = {
    CZK: "Kč",
    EUR: "€",
    MDL: "L",
    PLN: "zł",
    UAH: "₴",
    USD: "$",
};

const CurrencyDefault = "USD";

export { CurrencyList, Currency2Symbol, CurrencyDefault };
